import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOfferOnDiscountDetail } from "src/models/Offers/OfferOnDiscount.models";

interface OfferOnDiscountDetailState {
  offerOnDiscountDetails: IOfferOnDiscountDetail[];
  offerOnDiscountDetailToEdit: IOfferOnDiscountDetail | null;
}

const initialState: OfferOnDiscountDetailState = {
  offerOnDiscountDetails: [],
  offerOnDiscountDetailToEdit: null,
};

const OfferOnDiscountDetailSlice = createSlice({
  name: "OfferOnDiscountDetail",
  initialState,
  reducers: {
    setOfferOnDiscountDetailList: (
      state,
      action: PayloadAction<IOfferOnDiscountDetail[]>
    ) => {
      state.offerOnDiscountDetails = action.payload;
    },
    concatListOfferOnDiscountDetail: (
      state: OfferOnDiscountDetailState,
      action: PayloadAction<IOfferOnDiscountDetail[]>
    ) => {
      state.offerOnDiscountDetails = [
        ...state.offerOnDiscountDetails.concat(action.payload),
      ];
    },
    setOfferOnDiscountDetailToEdit: (
      state,
      action: PayloadAction<IOfferOnDiscountDetail | null>
    ) => {
      state.offerOnDiscountDetailToEdit = action.payload;
    },
    addOfferOnDiscountDetail: (
      state,
      action: PayloadAction<IOfferOnDiscountDetail>
    ) => {
      state.offerOnDiscountDetails.push(action.payload);
    },
    updateOfferOnDiscountDetail: (
      state,
      action: PayloadAction<IOfferOnDiscountDetail>
    ) => {
      let itemIndex = state.offerOnDiscountDetails.findIndex(
        item =>
          item.offerOnDiscountDetailId ===
          action.payload.offerOnDiscountDetailId
      );
      if (itemIndex !== -1)
        state.offerOnDiscountDetails[itemIndex] = action.payload;
    },
    deleteOfferOnDiscountDetail: (state, action: PayloadAction<number>) => {
      const newArray = state.offerOnDiscountDetails.filter(
        item => item.offerOnDiscountDetailId !== action.payload
      );
      state.offerOnDiscountDetails = newArray;
    },
  },
});

export const {
  setOfferOnDiscountDetailList,
  concatListOfferOnDiscountDetail,
  setOfferOnDiscountDetailToEdit,
  addOfferOnDiscountDetail,
  updateOfferOnDiscountDetail,
  deleteOfferOnDiscountDetail,
} = OfferOnDiscountDetailSlice.actions;

export default OfferOnDiscountDetailSlice.reducer;
